t = require('app/scripts/views/internal/teacup-with-helpers')('board_menu_about_this_board')

actionsPartial = t.renderable (canComment, canVote, headerKey) ->
  if canComment || canVote
    t.div '.about-this-board-actions-section', ->
      t.h2 '.small-caps', ->
        t.format headerKey
      t.ul '.pop-over-list.inset', ->
        if canComment
          t.li ->
            t.span '.icon-sm.icon-comment'
            t.format 'comment-on-cards'
        if canVote
          t.li ->
            t.span '.icon-sm.icon-vote'
            t.format 'vote-on-cards'

module.exports = t.renderable ({ isLoggedIn, isAdmin, isNonAdminMember, canComment, canVote, commentHeader, votingHeader,
permissionsHierarchy, isTemplate }) ->

  if isTemplate && !isAdmin
    t.div '.js-search-input-view'
    t.hr()

  # Admin/s profiles
  t.div '.about-this-board-section', ->
    t.div '.window-module-title.window-module-title-no-divider', ->
        t.span '.icon-member.icon-lg.window-module-title-icon'
        t.h3 '.u-inline-block', ->
          t.format 'made-by'

    # Single admin
    t.div '.js-made-by'

    # Multi admin
    t.div '.about-this-board-multi-admin', ->
      t.div '.js-made-by-facepile'
      t.a '.admin-count.about-this-board-pile-button.pile.js-fill-board-admin-count', { href: '#' }, ->
        t.span '.admin-count-notifications'

  # Copy & View counts
  t.div '.js-view-copy-count'

  # Description
  t.div '.about-this-board-section.about-this-board-desc', ->
    t.div '.js-fill-atb-desc.about-this-board-description-content'

  # Commenting and voting permissions
  if !isTemplate && !isNonAdminMember && (canComment || canVote)
    t.div '.about-this-board-section', ->
      t.hr()
      if isAdmin
        if permissionsHierarchy == 'equal'
          actionsPartial(canComment, canVote, commentHeader)
        else if permissionsHierarchy == 'comment'
          actionsPartial(canComment, null, commentHeader)
          actionsPartial(null, canVote, votingHeader)
        else
          actionsPartial(null, canVote, votingHeader)
          actionsPartial(canComment, null, commentHeader)
        t.a '.quiet-button.js-change-permissions', { href: "#" }, ->
          t.span -> t.format 'change-permissions'
      else
        actionsPartial(canComment, canVote, 'any-trello-user-can')
